import { appRoutes } from "@/app/router";
import { observer } from "mobx-react-lite";
import { FC } from "react";
import { Link } from "react-router-dom";

interface DebugDbPageProps {}

export const DebugDbPage: FC<DebugDbPageProps> = observer(() => {
  return (
    <div>
      <div>Database tools</div>
      <Link to={appRoutes.debugDbRepl({}).path}>Open REPL</Link>
    </div>
  );
});
